import { DEBRIEF_DECISIONS, toLocalDtString } from './debriefModel';
import { toUtcIso } from '../../../utils/Utils';

// Karar formunun GenericFormDrawer şeması — SAF (render gerektirmeden sınanır).
//
// OVERRIDE KURALI (SPEC F4): tüm katılımcılar skorkartını göndermeden kayıt
// sunucuda 409 `ats.debrief.pendingScorecards`'tır; YALNIZ AT.Write/admin bir
// gerekçe (`overrideReason`) vererek geçebilir. Bu yüzden alan yalnız
// "eksik gönderim + yazma yetkisi" birlikteyken çizilir ve ZORUNLUDUR.
// Yetkisiz (ör. kadronun HM'i) eksik gönderimde formu hiç açamaz — sayfa
// bunun yerine açıklama gösterir (bkz. needsOverride / canSubmitWithPending).
export const needsOverride = ({ allSubmitted, writable }) => !allSubmitted && !!writable;
export const blockedByPending = ({ allSubmitted, writable }) => !allSubmitted && !writable;

export function buildDebriefSchema({
  t, allSubmitted, writable, searchPeople, getPersonById,
}) {
  const schema = [
    {
      name: 'decision',
      type: 'select',
      label: t('ats.debrief.form.decision'),
      required: true,
      options: DEBRIEF_DECISIONS.map((d) => ({ id: d, name: t(`ats.debrief.decision.${d}`) })),
    },
    {
      name: 'heldAt',
      type: 'datetime',
      label: t('ats.debrief.form.heldAt'),
      required: true,
      grid: 6,
    },
    {
      name: 'facilitatorUserId',
      type: 'asyncSelect',
      label: t('ats.debrief.form.facilitator'),
      required: true,
      onSearch: searchPeople,
      onGetById: getPersonById,
      minChars: 0,
      grid: 6,
    },
    {
      name: 'attendeeUserIds',
      type: 'asyncSelect',
      label: t('ats.debrief.form.attendees'),
      isMulti: true,
      onSearch: searchPeople,
      onGetById: getPersonById,
      minChars: 0,
    },
    {
      name: 'summary',
      type: 'textarea',
      label: t('ats.debrief.form.summary'),
      required: true,
      rows: 6,
      description: t('ats.debrief.form.summaryHint'),
    },
  ];

  if (needsOverride({ allSubmitted, writable })) {
    schema.unshift({
      name: 'overrideNotice',
      type: 'notice',
      tone: 'warning',
      content: t('ats.debrief.form.overrideNotice'),
    });
    schema.push({
      name: 'overrideReason',
      type: 'textarea',
      label: t('ats.debrief.form.overrideReason'),
      required: true,
      rows: 3,
    });
  }
  return schema;
}

/** Kayıtlı debrief → form başlangıç değerleri (düzenleme). Yeni kayıtta öneri değerler. */
export function debriefInitialValues(debrief, { evaluators = [], now = new Date() } = {}) {
  if (debrief) {
    return {
      decision: debrief.decision || null,
      heldAt: toLocalDtString(debrief.heldAt),
      facilitatorUserId: debrief.facilitatorUserId || null,
      attendeeUserIds: Array.isArray(debrief.attendeeUserIds)
        ? debrief.attendeeUserIds
        : (debrief.attendees || []).map((a) => a.userId).filter(Boolean),
      summary: debrief.summary || '',
      overrideReason: debrief.overrideReason || '',
    };
  }
  return {
    decision: null,
    heldAt: toLocalDtString(now.toISOString()),
    facilitatorUserId: null,
    // Varsayılan katılımcılar: paneldeki değerlendiriciler (sık durum).
    attendeeUserIds: evaluators.map((e) => e.userId).filter(Boolean),
    summary: '',
    overrideReason: '',
  };
}

/** Form verisi → istek gövdesi. overrideReason yalnız gerekiyorsa gönderilir. */
export function toDebriefRequest(form, { allSubmitted, writable }) {
  const body = {
    decision: form.decision,
    summary: (form.summary || '').trim(),
    heldAt: toUtcIso(form.heldAt),
    facilitatorUserId: form.facilitatorUserId || null,
    attendeeUserIds: Array.isArray(form.attendeeUserIds) ? form.attendeeUserIds : [],
  };
  if (needsOverride({ allSubmitted, writable })) {
    body.overrideReason = (form.overrideReason || '').trim();
  }
  return body;
}
